export default __webpack_public_path__ + "static/media/PASL.80a6ff44.png";